import "./formulario.css";
import CampoTexto from "../CampoTexto";
import ListaSuspensa from "../ListaSuspensa";
import Botao from "../botao";
import { useState } from "react";

const Formulario = (props) => {

  const [nome, setNome] = useState("");
  const [cargo, setCargo] = useState("");
  const [imagem, setImagem] = useState("");
  const [time, setTime] = useState('');

  const aoSalvar = (evento) => {
    evento.preventDefault();

    props.aoColaboradorCadastrado({
      nome,
      cargo,
      imagem,
      time
    })
    setNome('')
    setCargo('')
    setImagem('')
    setTime('')
    
  };
  return (
    <section className="fundo">
      <form onSubmit={aoSalvar}>
        <h2>Preencha os dados para criar o card do colaborador</h2>
        
        <CampoTexto 
          obrigatorio={true} 
          label="Nome" 
          place="Digite seu nome" 
          valor = {nome}
          aoAlterado={valor => setNome(valor)}  
        />

        <CampoTexto 
          obrigatorio={true} 
          label="Cargo" 
          place="Digite seu cargo" 
          valor = {cargo}
          aoAlterado={valor => setCargo(valor)}  
        />

        <CampoTexto 
          label="Imagem" 
          place="Informe o endereço da imagem" 
          valor = {imagem}
          aoAlterado={valor => setImagem(valor)}  
        />

        <ListaSuspensa 
          obrigatorio={true} 
          label="Time" 
          itens={props.times} 
          valor={time}
          aoAlterado={valor => setTime(valor)}
        />
        <Botao>Criar Card</Botao>
      </form>
    </section>
  );
};
export default Formulario;
